import { Amparo } from "./Amparo";

export class Producto{
    valorContrato: string;
    fechaExpedicion: string;
    fechaVigenciaDesde: string;
    fechaFinConstitucion: string;
    objetoContrato: number;
    clausulado: number;
    giroNegocio: number;
    numeroContrato: string;
    amparos: Amparo[];

    constructor(){
        this.valorContrato="";
        this.fechaExpedicion="";
        this.fechaVigenciaDesde="";
        this.fechaFinConstitucion="";
        this.objetoContrato=null;
        this.clausulado=null;
        this.giroNegocio=null;
        this.numeroContrato="";
        this.amparos=[];
    }
}